import type { LocalInterview } from '@Domain/Ports/LocalInterviews/LocalInterviewPort';

/**
 * Finds, among `candidates`, the local interview matching a server-side identity: `interviewId`
 * first (a fact written locally by `attachServerIdentity`, true regardless of whether the server
 * list has caught up yet), falling back to `clientReference` for a device that lost that write.
 *
 * Takes `candidates` rather than deciding on its own which local interviews are eligible: a caller
 * that must exclude interviews already matched elsewhere (the interview list, matching one server
 * entry at a time) filters its own array before calling, so that a caller with no such constraint
 * (the detail screen, resolving a single subject) is never forced to carry it.
 */
const findLocalInterviewMatch = (
	interviewId: number | null,
	clientReference: string | null,
	candidates: readonly LocalInterview[],
): LocalInterview | null => {
	const matchedByInterviewId =
		interviewId !== null
			? (candidates.find((candidate) => candidate.interviewId === interviewId) ?? null)
			: null;

	if (matchedByInterviewId !== null) {
		return matchedByInterviewId;
	}

	return clientReference !== null
		? (candidates.find((candidate) => candidate.id === clientReference) ?? null)
		: null;
};

export default findLocalInterviewMatch;
